import { Accordion, AccordionDetails, AccordionSummary, Card, Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { DATE_FORMATS } from "lib/@constants/date-format"
import Iconify from "minimals-template/components/Iconify"
import { ScheduleIntroNotes } from "./schedule-intro-notes"
import { createSlot } from "lib/@components/slot/create-slot"
import { If } from "lib/@components/switch"

export const ScheduleOverviewExtraContext = createSlot("ScheduleOverviewExtraContext")

export function ScheduleOverview({ cardSx = {}, showHeader = true, ...accordionProps }) {
    const { version, schedule, taskCount } = useBoundContext()
    const { metadata, code: scheduleCode, version: scheduleVersion } = schedule
    return (
        <Card sx={cardSx}>
            <Accordion defaultExpanded={true} {...accordionProps}>
                <AccordionSummary
                    expandIcon={
                        <Iconify
                            icon={open ? "eva:arrow-ios-downward-fill" : "eva:arrow-ios-forward-fill"}
                            sx={{ width: 16, height: 16, ml: 1 }}
                            data-cy="expand-collapse-schedule-overview"
                        />
                    }
                    {...accordionProps}
                    sx={{ ml: 1 }}
                >
                    <If truthy={showHeader}>
                        <Typography variant="h6">Schedule Overview</Typography>
                    </If>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, m: 2 }}>
                    <Stack mt={2} direction="row" sx={{ justifyContent: "space-between", ml: 1, mb: 2 }}>
                        <Stack mr="auto" data-cy="schedule-details-version">
                            <Typography variant="subtitle2">VERSION</Typography>
                            <Typography variant="body2">{version != "no_v" ? version : scheduleVersion}</Typography>
                        </Stack>
                        <Stack mr="auto" data-cy="schedule-details-published-date">
                            <Typography variant="subtitle2">PUBLISHED</Typography>
                            <Typography variant="body2">
                                {Date.create(metadata?.published).format(DATE_FORMATS.medium)}
                            </Typography>
                        </Stack>
                        <Stack mr="auto" data-cy="schedule-details-code">
                            <Typography variant="subtitle2">CODE</Typography>
                            <Typography variant="body2">{scheduleCode}</Typography>
                        </Stack>
                        <Stack mr="auto" data-cy="schedule-details-tasks-count">
                            <Typography variant="subtitle2">TASKS</Typography>
                            <Typography variant="body2">{taskCount}</Typography>
                        </Stack>
                    </Stack>
                    <ScheduleIntroNotes />
                </AccordionDetails>
                <ScheduleOverviewExtraContext.Slot />
            </Accordion>
        </Card>
    )
}
